import { defu } from 'defu'
import routerOptions from '#build/router.options.mjs'
const sensitiveMatcher = /* @__PURE__ */ (() => { const $0={}; return (m,p)=>{let r=[];if(p.charCodeAt(p.length-1)===47)p=p.slice(0,-1);if(p==="/api/search"){r.push({data:$0});}else if(p==="/api/city-search"){r.push({data:$0});}else if(p==="/api/organisation-search"){r.push({data:$0});}else if(p.charCodeAt(p.length-1)===47){if(p==="/api/search/"){r.push({data:$0});}else if(p==="/api/city-search/"){r.push({data:$0});}else if(p==="/api/organisation-search/"){r.push({data:$0});}}let s=p.split("/");if(s.length>1&&s[s.length-1]===""){s.pop();p=p.slice(0,-1)}let l=s.length;if(l>1){if(s[1]==="omni-search"){if(l>2){if(s[2]==="search"){if(l>3){if(s[3]==="universities"){r.push({data:$0,params:{"_":p.slice(33),}});}}r.push({data:$0,params:{"_":p.slice(20),}});}}}else if(s[1]==="search"){r.push({data:$0,params:{"_":p.slice(8),}});}else if(s[1]==="_nuxt"){r.push({data:$0,params:{"_":p.slice(7),}});}}return r.reverse();}})()
const foldedMatcher = sensitiveMatcher
const decodeRoutePath = function decodeRoutePath(path) {
	if (!path.includes("%")) return path;
	const queryIndex = path.indexOf("?");
	const pathname = queryIndex === -1 ? path : path.slice(0, queryIndex);
	try {
		return queryIndex === -1 ? decodeURI(pathname) : decodeURI(pathname) + path.slice(queryIndex);
	} catch {
		return path;
	}
}
const normalizePath = (path, fold) => {
  if (typeof path !== 'string') { return path }
  const decoded = decodeRoutePath(path)
  return fold ? decoded.toLowerCase() : decoded
}
export default (path) => routerOptions.sensitive
  ? defu({}, ...sensitiveMatcher('', normalizePath(path, false)).map(r => r.data).reverse())
  : defu({}, ...foldedMatcher('', normalizePath(path, true)).map(r => r.data).reverse())